export enum Provider {
  KDK = "KDK",
  CERTES = "CERTES",
  STACJANO = "STACJANO",
  PROCESS_TEAM = "PROCESS TEAM",
  KIG = "KIG",
  CTS = "CTS",
  CZK = "CZK",
  LIPH = "LIPH",
  QS = "QS",
  DGA = "DGA"
}

export enum EducationOptions {
  Podstawowe = "Podstawowe",
  Gimnazjalne = "Gimnazjalne",
  Zawodowe = "Zawodowe",
  Branżowe = "Branżowe",
  Średnie = "Średnie",
  Wyższe = "Wyższe"
}

export enum SettlementOptions {
  ogolne = "na zasadach ogólnych",
  liniowe = "według stawki liniowej",
  ryczalt = "ryczałtem od przychodów ewidencjonowanych"
}